import React from 'react'
import CardContracts from './CardContracts'
import EmptyContracts from './EmptyContracts'
import styles from '../../../styles'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import Link from '../../../components/link/Link'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { RootState } from '../../reducers'
import { ClassValue } from 'classnames/types'

const useStyle = makeStyles((theme) => {
    return {
        ...styles(theme),
        dashboardContractsLargeScreenStyle: {
            width: '33%'
        },
        dashboardContractsSmallScreenStyle: {
            width: '100%'
        },
        headerContractStyle: {
            marginBottom: 25,

            '& h1': {
                color: theme.palette.blue.main
            }
        },
        linkStyle: {
            justifyContent: 'flex-end'
        }
    }
})

interface Store {
    contractsSaved: ContractsModel[]
}

interface AcceptingProps {
    isLargeScreen: boolean
}

type DashboardContractsProps =
    AcceptingProps
    & Store

const DashboardContracts: React.FC<DashboardContractsProps> = (
    {
        isLargeScreen,
        contractsSaved
    }
) => {
    const classes = useStyle()
    const history = useHistory()

    const dashboardContractsClass = classNames(
        {
            [classes.dashboardContractsLargeScreenStyle]: isLargeScreen,
            [classes.dashboardContractsSmallScreenStyle]: !isLargeScreen
        }
    )
    const headerContractClass = classNames(
        'row',
        classes.flexBetween,
        classes.alignCenter,
        classes.headerContractStyle
    )

    const linkAllClass: ClassValue = classNames(
        'col-xs-12 col-sm-6 col-md-12 col-lg-6',
        classes.linkStyle
    )

    const seeContracts = () => {
        history.push(links.contracts)
    }

    return (
        <div className={dashboardContractsClass}>
            <div className={headerContractClass}>
                <h1
                    className={classes.title3}
                >
                    <FormattedMessage
                        id="dashboard.contracts.title"
                        defaultMessage="Votre compte"
                        description="Dashboard account title"
                    />
                </h1>

                <Link
                    textStyle="text8"
                    color="colorAccessibility"
                    onClick={seeContracts}
                    className={linkAllClass}
                >
                    <FormattedMessage
                        id="dashboard.contracts.link"
                        defaultMessage="Tous vos contrats"
                        description="Dashboard contract link text"
                    />
                </Link>
            </div>

            {
                contractsSaved.length > 0 ? (
                    contractsSaved.slice(0, 2).map(
                        (contract) => (
                            <CardContracts
                                key={contract.id}
                                contract={contract}
                                isLargeScreen={isLargeScreen}
                            />
                        )
                    )
                ) : (
                    <EmptyContracts />
                )
            }
        </div>
    )
}

const mapStateToProps = (state: RootState) => (
    {
        contractsSaved: state.contracts
    }
)

export default connect(mapStateToProps)(DashboardContracts)
